(function() {
  var params = new URLSearchParams(window.location.search);
  var utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  
  var hasUtm = utmKeys.some(function(k) { return params.get(k); });
  
  if (hasUtm) {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('utm_first_touch') || '{}'); } catch(e) {}
    
    if (Object.keys(stored).length === 0) {
      var utms = {};
      utmKeys.forEach(function(k) {
        if (params.get(k)) utms[k] = params.get(k);
      });
      sessionStorage.setItem('utm_first_touch', JSON.stringify(utms));
    }
  }
  
  var toWrite = {};
  try { toWrite = JSON.parse(sessionStorage.getItem('utm_first_touch') || '{}'); } catch(e) {}
  
  if (Object.keys(toWrite).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: toWrite })
    });
  }
})();